import { Fragment, useContext } from 'react';
import { AppContext } from '../contexts/AppContext';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row } from 'react-bootstrap';
import { Divider } from 'theme-ui';
import { DeliveryStatusType, PackageStatusType } from '../contexts/contextTypes';
import TrackingHistory from '../components/TrackingHistory';
import DeliveryInstructions from '../components/DeliveryInstructions';
import CustomerSupport from '../components/CustomerSupport';
import BankIDVerification from '../components/BankIDVerification';
import MapContainer from '../components/Dashboard/MapContainer';
import FailedContainer from '../components/Dashboard/FailedContainer';
import PendingContainer from '../components/Dashboard/PendingContainer';
import CompletedContainer from '../components/Dashboard/CompletedContainer';
import DeliveryRequirementBadge from '../components/DeliveryInstructions/DeliveryRequirementBadge';

const Dashboard = ({ isCustomerService }: { isCustomerService: boolean }) => {
  const { t } = useTranslation();
  const { trackingDetails } = useContext(AppContext);
  const taskStatus = trackingDetails?.task?.status;

  const showCustomerSupport =
    !isCustomerService &&
    (taskStatus === DeliveryStatusType.FAILED ||
      trackingDetails?.package?.status === PackageStatusType.CANCELLED ||
      (trackingDetails?.package?.originalCompleteAfter !== trackingDetails?.task?.completeAfter &&
        trackingDetails?.package?.originalCompleteBefore !== trackingDetails?.task?.completeBefore) ||
      (taskStatus === DeliveryStatusType.IN_PROGRESS &&
        trackingDetails?.eta?.predictedArrival &&
        trackingDetails?.eta.lowerBound &&
        new Date(trackingDetails?.eta?.lowerBound).getTime() < Date.now() &&
        trackingDetails?.stopsAhead === 0));

  return (
    <Fragment>
      {taskStatus === DeliveryStatusType.IN_PROGRESS ? (
        <MapContainer />
      ) : taskStatus === DeliveryStatusType.COMPLETED ? (
        <CompletedContainer />
      ) : taskStatus === DeliveryStatusType.FAILED ? (
        <FailedContainer />
      ) : (
        <PendingContainer />
      )}
      <Divider style={{ marginTop: 20 }} />

      <DeliveryRequirementBadge
        userRequirements={trackingDetails?.package?.userDeliveryRequirements}
        partnerRequirements={{
          identificationCheckRequired: trackingDetails?.task?.identificationCheckRequired,
          recipientMinimumAge: trackingDetails?.task?.recipientMinimumAge,
          recipientMustMatchEndCustomer: trackingDetails?.task?.recipientMustMatchEndCustomer,
          requireSignature: trackingDetails?.task?.requireSignature
        }}
      />

      <BankIDVerification isCustomerService={isCustomerService} />
      <TrackingHistory />
      <Divider style={{ marginTop: 20, marginBottom: 0 }} />
      <Container>
        <Row className="package_history">
          <Col>
            <div className="package_history--header">{t('deliveryInstructions.heading')}</div>
            <DeliveryInstructions isCustomerService={isCustomerService} />
          </Col>
        </Row>
      </Container>
      {showCustomerSupport && <CustomerSupport />}
    </Fragment>
  );
};

export default Dashboard;
